import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getPracticeLocations } from 'api/Practice';

export const usePracticeLocations = () => {
  const navigate = useNavigate();
  return useQuery(['practiceLocations'], () => getPracticeLocations(navigate), {
    refetchOnMount: false,
    refetchOnWindowFocus: false
  });
};
